var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyBagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8 2 C 8.5 1.5, 10 1, 12 1 C 14 1, 15.5 1.5, 16 2 L 14.5 6 L 9.5 6 Z",
    fill: "transparent",
    stroke: "#2d3e5c",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 9.5 6 C 6 10, 3 14, 3 18 C 3 21, 5 23, 9 23 L 15 23 C 19 23, 21 21, 21 18 C 21 14, 18 10, 14.5 6 Z",
    fill: "transparent",
    stroke: "#2d3e5c",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2d3e5c",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14.5,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.8,
    y1: 12.3,
    x2: 8.3,
    y2: 10.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.2,
    y1: 12.3,
    x2: 15.7,
    y2: 10.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.8,
    y1: 16.7,
    x2: 8.3,
    y2: 18.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.2,
    y1: 16.7,
    x2: 15.7,
    y2: 18.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBagIcon);
export default __webpack_public_path__ + "static/media/money-bag-icon.71f58356dc27068ad0b864f93d9f2ddc.svg";
export { ForwardRef as ReactComponent };